export default "/_next/static/chunks/bust-hi.bfda6ac626babf3f56939a0a435c002c.glb";